import TaxesGrid from "./TaxesGrid"
import React, { useEffect, useState } from "react"
import PropTypes from "prop-types"
import Dialog from "@mui/material/Dialog"
import DialogTitle from "@mui/material/DialogTitle"
import DialogContent from "@mui/material/DialogContent"
import DialogActions from "@mui/material/DialogActions"
import Button from "@mui/material/Button"
import { useTaxes } from "./hooks/useTaxes"
import i18n from "i18n"

const ModalTaxesSettings = ({ open, onClose, organizationId }) => {
  const { data: taxes = [], isLoading } = useTaxes(organizationId, open)
  const [taxesState, setTaxesState] = useState([])

  useEffect(() => {
    if (open && taxes) {
      setTaxesState(taxes)
    }
  }, [open, organizationId, taxes])

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>{i18n.t("taxes.taxes")}</DialogTitle>
      <DialogContent>
        <TaxesGrid
          taxes={taxesState}
          onTaxesChange={setTaxesState}
          organizationId={organizationId}
        />
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 2 }}>
        <Button
          onClick={onClose}
          color="branded"
          variant="contained"
          sx={{ width: "106px", height: "36px" }}
        >
          {i18n.t("Cerrar")}
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default ModalTaxesSettings

ModalTaxesSettings.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  organizationId: PropTypes.string.isRequired,
}
